import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { playerTaskDetail } from "@/api/gmToolNew/gmToolNew";
import { tabulation, gmToolNew } from "@/mixins/index";
export default {
  name: "playerLevelDetails",
  mixins: [tabulation, gmToolNew],
  data: function data() {
    return {
      date: [],
      paramsData: {
        task_type: "daily_task",
        role_ids: '',
        page: 1
      },
      exportLoading: false,
      total: 0,
      typeList: [{
        label: this.$t('levelLabel'),
        value: 'daily_task'
      }, {
        label: this.$t('dailyTask'),
        value: 'main_line_task'
      }]
    };
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      if (!this.paramsData.role_ids) {
        this.$message.error(this.$t('pleaseEnterRoleId'));
        return;
      }

      this.paramsData.page = e;
      this.paramsData.starttime = this.date && this.date[0];
      this.paramsData.endtime = this.date && this.date[1];
      this.reqLoading = true;
      playerTaskDetail(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                playerTaskDetail(_objectSpread(_objectSpread({}, _this2.paramsData), {}, {
                  page_size: -1
                })).then(function (res) {
                  if (res.status == 200) {
                    var list = res.data.data;
                    var columns = [{
                      label: _this2.$t('game'),
                      prop: 'game'
                    }, {
                      label: _this2.$t('platform'),
                      prop: 'platform'
                    }, {
                      label: _this2.$t('channel'),
                      prop: 'channel'
                    }, {
                      label: _this2.$t('packageName'),
                      prop: 'pkg'
                    }, {
                      label: _this2.$t('userId'),
                      prop: 'user_id'
                    }, {
                      label: _this2.$t('serverId'),
                      prop: 'server_id'
                    }, {
                      label: _this2.$t('roleName'),
                      prop: 'role_name'
                    }, {
                      label: _this2.$t('roleId'),
                      prop: 'role_id'
                    }, {
                      label: _this2.$t('actionTime'),
                      prop: 'time'
                    }, {
                      label: _this2.$t('task'),
                      prop: 'task'
                    }, {
                      label: _this2.$t('registerTime'),
                      prop: 'register_time'
                    }, {
                      label: _this2.$t('lastLoginTime'),
                      prop: 'last_login_time'
                    }, {
                      label: _this2.$t('roleRechargeAmount'),
                      prop: 'recharge_amount'
                    }];

                    _this2.$export.excel({
                      columns: columns,
                      data: list,
                      title: _this2.$route.meta.title
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};